import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import moment from 'moment';

import './SignInScreen.css';

import UserModel from '../components/UserModel';

import { Layout, Form, Icon, Input, Button, Checkbox, Spin, message } from 'antd';
const { Content } = Layout;
const FormItem = Form.Item;

class SignInScreen extends Component {

  state = {
    isLoading: false,
    isAuthenticated: false
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          isLoading: true
        });
        UserModel.login(values)
          .then(r => {
            this.setState({
              isLoading: false,
              isAuthenticated: true
            });
            window.location.href = "/";
          })
          .catch(err => {
            if (err.response && err.response.data && err.response.data.error && err.response.data.error.code == 'INVALID_CREDENTIALS') {
              message.warning('Chybně zadané heslo nebo uživatelské jméno!');
            } else {
              message.error('Nastala neočekávaná chyba při přihlašování!');
            }
            this.setState({
              isLoading: false
            });
          });
      }
    });
  }

  renderForm() {

    const { getFieldDecorator } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit} className="login-form">
        <FormItem>
          {getFieldDecorator('username', {
            rules: [{ required: true, message: 'Zadejte prosím uživatelské jméno!' }],
          })(
            <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Uživatelské jméno" />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Zadejte prosím heslo!' }],
          })(
            <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Heslo" />
          )}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit" className="login-form-button">
            Přihlásit
          </Button>
        </FormItem>
      </Form>
    )
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: "/" } };    

    if (this.state.isAuthenticated || UserModel.isAuthenticated()) {
      return <Redirect to={from} />;
    } 

    return (
      <Content style={{ margin: '24px 16px 0' }}>
        <div style={{ padding: 24, width: 320, boxShadow: '0 0 100px rgba(0,0,0,.08)', position: 'absolute', top: '50%', left: '50%', margin: '-160px 0 0 -160px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div className="logo" style={{ width: 170, height: 38, background: 'url("https://smart4city.cz/img/s4c_logo_1.png")', backgroundSize: '100% 100%', margin: 16, marginBottom: 30}} />
          </div>
          {this.state.isLoading 
            ? <Spin>{this.renderForm()}</Spin> 
            : this.renderForm() }
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <p style={{fontSize: 10}}>Smart4City ©{moment().format('YYYY')} Created by SPEL a.s.</p>
          </div>
        </div>
      </Content>
    );
  }
}

const Wrapped = Form.create()(SignInScreen);

export default Wrapped;



// WEBPACK FOOTER //
// ./src/screens/SignInScreen.js